<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
      <img src="@/assets/img/logo_white.jpg" alt="logo图">
    </div>
    <p class="title">筝语古筝</p>
    <p class="address_tel_fax">
      <span>深圳市众邺科技有限公司</span>
    </p>
    <p class="email_wx">
      <span>邮箱：yangbo8080@qq.com</span>
      <span>公司公众号：古筝笔记</span>
    </p>

    <div  class="information-title" @click="toRescue">
      粤ICP备15005586号-1
    </div>

    <p class="copy">Copyright &copy; 2013 - 2023 深圳市众邺科技有限公司 </p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {
      url: 'https://beian.miit.gov.cn/',
    };
  },
  methods: {
    toRescue() {
      window.location.href = this.url;
    },
  },
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
.information-title {
  color: #ffffff;
  font-size: 14px;
  cursor: pointer;  /*鼠标悬停变小手*/
  width: 100%;
}
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue